// Google Analytics integration

// Track user registration
function trackRegistration(userId, signUpSource) {
  if (typeof gtag === 'function') {
    gtag('event', 'sign_up', {
      'user_id': userId,
      'sign_up_method': signUpSource || 'unknown',
      'engagement_time_msec': 1000,
      'session_id': Date.now(),
      'page_location': window.location.href,
      'page_referrer': document.referrer
    });
  }
}

// Track custom events
function trackEvent(category, action, label, value) {
  if (typeof gtag === 'function') {
    gtag('event', action, {
      'event_category': category,
      'event_label': label,
      'value': value
    });
  }
}

// Export functions for use in other modules
window.trackRegistration = trackRegistration;
window.trackEvent = trackEvent;